export default __webpack_public_path__ + "static/media/2411152.3b1755d0.webp";